import type { PerspectiveCamera, Scene, SceneControl } from '@anov/3d-core'
import { AnimationMixer, BoxGeometry, Mesh, lib } from '@anov/3d-core'
import type { CharacterAnimationType } from './type'
import BasicCharacterControllerInput from './action/input'
import Camera_movement from './player/camera.js'
import Character_control from './player/control'
import Character_animation from './player/animation'

const { GLTFLoader } = lib

interface PropsType {
  scene: Scene
  camera: PerspectiveCamera
  sceneControl: SceneControl
}

export default class Player {
  character_control!: Character_control
  character_animation!: Character_animation
  camera_movement!: Camera_movement
  characterMixer!: AnimationMixer
  character: any
  characterRotateBox: any
  scene: Scene
  camera: PerspectiveCamera
  sceneControl?: SceneControl

  constructor({ camera, scene, sceneControl }: PropsType) {
    this.scene = scene
    this.camera = camera
    this.sceneControl = sceneControl
    this.initialize()
  }

  async initialize() {
    const glbLoader = new GLTFLoader()
    const characterGlb = (await glbLoader.loadAsync('./Character.glb'))
    const character = characterGlb.scene

    this.characterRotateBox = new Mesh(new BoxGeometry(1, 1, 1))
    this.character = character

    this.characterMixer = new AnimationMixer(characterGlb.scene)
    this.characterMixer.clipAction(characterGlb.animations[10]).play()

    const characterAnimations: CharacterAnimationType = {
      running: undefined,
      runningBack: undefined,
      walking: undefined,
      idle: undefined,
      jump: undefined,
      leftRun: undefined,
      rightRun: undefined,
      getHit: undefined,
      hit: undefined,
      hitSecond: undefined,
      roll: undefined,

    }

    this.scene.add(this.character)

    // register event
    const input = new BasicCharacterControllerInput()

    this.camera_movement = new Camera_movement({
      character: this.character,
      camera: this.camera,
      characterRotateBox: this.characterRotateBox,
      player: this,
      sceneControl: this.sceneControl,
    })

    this.character_animation = new Character_animation({
      animations: characterAnimations,
      input,
    })

    this.character_control = new Character_control({
      scene: this.scene,
      character: this.character,
      input,
      animation: this.character_animation,
      characterRotateBox: this.characterRotateBox,
      camera: this.camera,
    })
  }

  update(deltaT: number, customProps?: any) {
    if (this.character)
      this.characterRotateBox.position.copy(this.character.position)

    if (this.characterMixer)
      this.characterMixer.update(deltaT)

    // this.character_animation?.update(deltaT)
    // this.characterMixer?.update(deltaT)

    this.character_control?.update(deltaT)
    this.camera_movement?.update(deltaT)
  }
}
